import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "@reach/router";
import { navigate } from "@reach/router";
import { Button } from 'reactstrap';


class VideoList extends Component{

  //when <Link to=same url different param not work/>
  click = (e)=>{
    const url = this.props.data.url.startsWith('../') ? this.props.data.url.substring(3, this.props.data.url.length) : this.props.data.url;
    document.location.href = url;
    e.prefentDefault();
    return false;
  }

  render(){
    return(
      <>
      <li>
        <div className="pointer" onClick={this.click} >
        <div className="video-list-img">
          <img src={this.props.data.image} />
          {this.props.data.playicon &&
          <img className="btn-play-video" src="https://app.triyakom.com/artist_portal/old/btn-play-video.svg"/>
          }
        </div>
        <div className="video-list-text">
          <div>{this.props.data.title}</div>
        </div>
        </div>
      </li>
      </>
    );
  }
}

export default VideoList;
